// src/rds_ui/api/configAdminApi.js
//
// Migrated off raw fetch() onto the shared axios instance in
// src/api/client.js (see projectsApi.js in this folder for why).
import { api, getApiError } from "../../api/client";

const BASE = "/rds";

// ── Service Lines ─────────────────────────────────────────────────────────────

export async function addServiceLine(formData) {
  try {
    const res = await api.post(`${BASE}/config/service-lines`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Failed to add service line");
  }
}

export async function deleteServiceLine(id) {
  try {
    const res = await api.delete(`${BASE}/config/service-lines/${id}`);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Failed to delete service line");
  }
}

export async function deleteServiceLineByCode(code) {
  try {
    const res = await api.delete(`${BASE}/config/service-lines/by-code/${code}`);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Failed to delete service line");
  }
}

// ── Methodologies ─────────────────────────────────────────────────────────────

export async function addMethodology(formData) {
  try {
    const res = await api.post(`${BASE}/config/methodologies`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Failed to add methodology");
  }
}

export async function deleteMethodology(id) {
  try {
    const res = await api.delete(`${BASE}/config/methodologies/${id}`);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Failed to delete methodology");
  }
}

export async function deleteMethodologyByCode(code) {
  try {
    const res = await api.delete(`${BASE}/config/methodologies/by-code/${code}`);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e) || "Failed to delete methodology");
  }
}
